enum RouteNames {
  HOME = '/home',
  STORAGE_UNIT_DETAIL = '/storage-unit/:storageUnitId',
  WHITE_LIST = '/whitelist',
}

export const appRoutes = {
  home: RouteNames.HOME,
  storageUnitDetail: RouteNames.STORAGE_UNIT_DETAIL,
};

export const substituteRouteParams = (
  route: string,
  params: Record<string, string>
) => {
  let replacedRoute = route;

  // Detect if this is an external URL (starts with http:// or https://)
  const isExternalUrl = /^https?:\/\//.test(route);

  Object.entries(params).forEach(([key, value]) => {
    // For external URLs, encode the parameter values to handle special characters like %
    const encodedValue = isExternalUrl ? encodeURIComponent(value) : value;
    replacedRoute = replacedRoute.replace(`:${key}`, encodedValue);
  });

  return replacedRoute;
};
